import { useState } from 'react';
import { uaepassStart, apiError } from '@/api/account';
import { toast } from 'sonner';

// Official UAE PASS button style: black pill, white text, "UAE PASS" capitalised (docs.uaepass.ae design guidelines).
function UaePassMark() {
  return (
    <svg viewBox="0 0 32 32" className="h-5 w-5" aria-hidden="true">
      <rect x="2" y="4" width="28" height="24" rx="4" fill="none" stroke="currentColor" strokeWidth="2" />
      <circle cx="11" cy="14" r="3.2" fill="none" stroke="currentColor" strokeWidth="2" />
      <path d="M5.5 23c1-3 3.2-4.5 5.5-4.5s4.5 1.5 5.5 4.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M19 12h7M19 16h7M19 20h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export async function startUaePass({ intent = 'login', accountType = 'retail', lang = 'en' } = {}) {
  const { url } = await uaepassStart({ intent, account_type: accountType, lang });
  window.location.href = url;
}

export function UaePassButton({ testid, label = 'Sign in with UAE PASS', intent = 'login', accountType = 'retail', variant = 'black', className = '' }) {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      await startUaePass({ intent, accountType });
    } catch (err) {
      toast.error(apiError(err, 'UAE PASS is unavailable right now. Please try again.'));
      setBusy(false);
    }
  };
  const tone = variant === 'black'
    ? 'bg-[#121212] text-white border-[#121212] hover:bg-black'
    : 'bg-white text-[#121212] border-[#121212] hover:bg-[#FAFAFA]';
  return (
    <button type="button" data-testid={testid} onClick={go} disabled={busy}
      className={`w-full inline-flex min-h-[48px] items-center justify-center gap-3 rounded-full border px-5 font-heading font-bold text-sm transition-colors disabled:opacity-60 ${tone} ${className}`}>
      <UaePassMark /> {busy ? 'Connecting to UAE PASS…' : label}
    </button>
  );
}
